import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const SubCategory = ({
  updateSubcategories,
  subcategory,
  subcategoryIndex,
  imageBasePath
}) => (
  <React.Fragment>
    <FormGroup className="flex-100">
      <Label>Description</Label>
      <Input
        id="description"
        type="textarea"
        rows="4"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.description || ''}
      />
    </FormGroup>
    <FormGroup>
      <Label>
        Tile image <small className="text-lighter">{imageBasePath}</small>
      </Label>
      <Input
        id="image"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.image || ''}
      />
    </FormGroup>
    <FormGroup>
      <Label>
        Feature image 1 <small className="text-lighter">{imageBasePath}</small>
      </Label>
      <Input
        id="featureImage"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.featureImage || ''}
      />
    </FormGroup>
    <FormGroup>
      <Label>
        Feature image 2 <small className="text-lighter">{imageBasePath}</small>
      </Label>
      <Input
        id="featureImage2"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.featureImage2 || ''}
      />
    </FormGroup>
    <FormGroup>
      <Label>
        Feature image 3 <small className="text-lighter">{imageBasePath}</small>
      </Label>
      <Input
        id="featureImage3"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.featureImage3 || ''}
      />
    </FormGroup>
    <FormGroup className="flex-100">
      <Label>Skus</Label>
      <Input
        id="skus"
        type="textarea"
        rows="4"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.skus || ''}
      />
    </FormGroup>
    <FormGroup className="flex-100">
      <Label>Recommendations category</Label>
      <Input
        id="recommendations"
        onChange={e => updateSubcategories(e, subcategoryIndex)}
        value={subcategory.recommendations || ''}
        placeholder={'e.g. Web_COMPUTER_DESKS'}
      />
    </FormGroup>
  </React.Fragment>
);

export default SubCategory;



// WEBPACK FOOTER //
// ./src/components/categories/Subcategories/SubCategory.js